import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { SectionSubtitle, SectionTitle } from '@/features/priceCalculator/PurchaseForm/SectionHeading'
import { yStack } from 'ui/src/patterns/stack'
import { DeductibleSelector, type ProductOfferWithDeductible } from './DeductibleSelector'

type Props = {
  deductibles: Array<ProductOfferWithDeductible>
  selectedDeductibleId: string
  onDeductibleChange: (offerId: string) => void
  className?: string
}

export function DeductibleSection({ deductibles, selectedDeductibleId, onDeductibleChange, className }: Props) {
  const { t } = useTranslation('purchase-form')

  return (
    <section className={clsx(className, yStack({ gap: 'lg' }))}>
      <div>
        <SectionTitle>{t('OFFER_PRESENTER_DEDUCTIBLE_TITLE')}</SectionTitle>
        <SectionSubtitle>{t('OFFER_PRESENTER_DEDUCTIBLE_SUBTITLE')}</SectionSubtitle>
      </div>

      <DeductibleSelector
        offers={deductibles}
        selectedOfferId={selectedDeductibleId}
        onValueChange={onDeductibleChange}
      />
    </section>
  )
}
